export enum MetadataSchemaInputEnum {
  TextInput = 'TextInput',
  NumberInput = 'NumberInput',
  CheckboxInput = 'CheckboxInput',
  MetadataValueSelect = 'MetadataValueSelect',
  LengthInput = 'LengthInput',
  WeightInput = 'WeightInput',
  AngleInput = 'AngleInput',
}
